import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Flex } from "@mantine/core";

export const flexGrowable = css`
  flex: 1 1 auto;
`;

export const flexStable = css`
  flex: 0 0 auto;
`;

export const StandardLayoutTableWrapper = styled(Flex)`
  & *[role="grid"] {
    width: 100%;
    height: 100%;

    /* 🔥 다크 모드 대응 */
    body[data-mantine-color-scheme="dark"] & .dark {
      background-color: #1a1b1e;
      color: #ffffff;
      border-color: #2c2e33;
      --rdg-color: #fff;
      --rdg-border-color: #2c2e33;
      --rdg-background-color: #1a1b1e;
      --rdg-header-background-color: #25262b;
      --rdg-row-hover-background-color: #2c2e33;
      --rdg-row-selected-background-color: #2c2e33;
      --rdg-checkbox-color: #ffffff;
      --rdg-checkbox-focus-color: #61b8ff;
    }
  }
  min-height: 80px;
`;
